module.exports = __webpack_public_path__ + "static/media/housekeeping.ef40a621.png";